import { valueStoreFactory } from '../services/utils/valueStoreFactory';

export const routingConfigStore = valueStoreFactory();
